export const LANDING_PAGE_URL = 'https://vizion.space';
